import { Dayjs } from "dayjs";
import "dayjs/locale/th";

// Bold lead of the E-Tax dashboard heading; also the breadcrumb crumb that links
// back to the dashboard.
export const ETAX_TITLE = "การส่งใบกำกับภาษี";

const thaiMonth = (date: Dayjs): string => date.locale("th").format("MMMM YYYY");
const thaiDate = (date: Dayjs): string => date.locale("th").format("D MMM YYYY");

/**
 * Lighter-weight suffix rendered after the bold title.
 *
 * It describes the range the cards below it actually summarise, so the heading can never
 * claim one period while the figures cover another:
 *  - no range            → "ทั้งหมด" — with no date filter the API returns EVERY candidate
 *                          document ever, not this month's. The old copy printed
 *                          "ประจำเดือน <current month>" here, which read as "this month has
 *                          data" while the cards were actually showing an all-time total.
 *  - one whole month     → "ประจำเดือน <month> <year>"
 *  - anything else       → the explicit "<from> - <to>" span, open-ended if one bound is set
 */
export const getEtaxMonthSuffix = (
  dateFrom?: Dayjs | null,
  dateTo?: Dayjs | null,
): string => {
  const from = dateFrom?.isValid() ? dateFrom : null;
  const to = dateTo?.isValid() ? dateTo : null;

  if (!from && !to) return "ทั้งหมด";

  // A range that stays inside one calendar month reads as that month — this covers both
  // the default (1st → today) and an explicitly picked whole month.
  if (from && to && from.isSame(to, "month")) {
    return `ประจำเดือน ${thaiMonth(from)}`;
  }

  if (from && to) return `${thaiDate(from)} - ${thaiDate(to)}`;
  if (from) return `ตั้งแต่ ${thaiDate(from)}`;
  return `ถึง ${thaiDate(to as Dayjs)}`;
};

// Breadcrumb crumb that links back to the E-Tax dashboard (no month — just the title).
export const getEtaxBreadcrumbLabel = (): string => ETAX_TITLE;
